import { Component } from "react";
import { configSettings } from "../../config/configSettings";
import { Constants } from '../../config/appConstants';

// let headers = new Headers();
// headers.append('Content-Type', 'application/json');
// headers.append('Accept', 'application/json');

export default class Api extends Component {

    static Get(url, componentState) {
        url = configSettings.environment + url;
        let headers = {
            Pragma: 'no-cache',
            'Accept-Encoding': 'gzip, deflate, br',
        };
        if (componentState && componentState.props && componentState.props.user && componentState.props.user.accessToken && componentState.props.user.accessToken !== "") {
            headers = { ...headers, [Constants.AUTHORIZATION]: Constants.BEARER + Constants.SPACE + componentState.props.user.accessToken };
        }
        return new Promise((resolve) => {
            const options = {
                method: 'GET',
                headers
            };
            return fetch(url, options).then((response) => {
                return resolve(response.json());
            }).catch(error => {
                return resolve(error);
            });
        });
    }

    static Post(url, data, componentState, signal = null) {
        url = configSettings.environment + url;
        let headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Accept-Encoding': 'gzip, deflate, br',
        };
        if (componentState && componentState.props && componentState.props.user && componentState.props.user.accessToken && componentState.props.user.accessToken !== "") {
            headers = { ...headers, [Constants.AUTHORIZATION]: Constants.BEARER + Constants.SPACE + componentState.props.user.accessToken };
        }
        return new Promise((resolve) => {
            const options = {
                method: 'POST',
                headers,
                body: JSON.stringify(data),
                signal
            };
            return fetch(url, options).then((response) => {
                return resolve(response.json());
            }).catch(error => {
                console.log("ERROR", error);
                if (error?.name == 'AbortError') return { success: false };
                return resolve(error);
            });
        });
    }
}